import React from 'react';
import { SiCheckmarx } from "react-icons/si";
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";

const GamingLicenseServices = () => {

    return (
        <main className='main'>

            <IntroSection
                title="Gaming License Services"
                subtitle="Launch and Operate Your Online Gaming Business Legally"
                description =
                    "Offshore Advisory provides full support for obtaining <b>iGaming and Gambling Licenses</b> across multiple international jurisdictions. Whether you’re starting an <b>online casino, sportsbook, lottery, or eSports platform,</b> we help you secure the right license to operate legally, access payment providers, and build global credibility."
                badges={[
                    "Casino & Sportsbook Licenses",
                    "Lottery & Betting",
                    "eSports & Online Gaming"
                ]}
                buttonText="Request a Proposal →"
                buttonLink="/contact"
                imageSrc="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop"
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Do You Need a Gaming License?'
                        subtitle="Operating without a license exposes your business to:"
                        blocks={[
                            {
                                subtitle: "Operating without a license exposes your business to:",
                                items: [
                                    { icon: "❌", title: "Payment processor and banking restrictions" },
                                    { icon: "❌", title: "Limited access to advertising & affiliates" },
                                    { icon: "❌", title: "Lack of player trust and credibility" },
                                ]
                            },
                            {
                                subtitle: "With a gaming license, you gain:",
                                items: [
                                    { icon: "✔️", title: "Legal Compliance — operate under recognized regulators." },
                                    { icon: "✔️", title: "Access to Payment Gateways — card processors & crypto PSPs." },
                                    { icon: "✔️", title: "Player Trust — build credibility globally." },
                                    { icon: "✔️", title: "Advertising Rights — work with affiliates & marketing platforms." },
                                ]
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Types of Gaming Licenses We Offer'
                        features={
                            [
                                { title: "Online Casino License", text: "(slots, table games, live dealer)" },
                                { title: "Sportsbook & Betting License", text: "(fixed odds, live betting, eSports)" },
                                { title: "Lottery & Sweepstakes License", },
                                { title: "Skill Games License", text: "(poker, fantasy sports, competitions)" },
                                { title: "eSports & Virtual Games License"},
                                { title: "Crypto Gaming License", text: "(provably fair games, tokenized platforms)" },
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Jurisdiction We Offer'
                        item={
                            [
                                { title: 'Western Sahara (CRA)', text: 'Fast approval, flexible multi-sector licensing' },
                                { title: 'Anjouan (Comoros)', text: 'Quick, cost-effective, crypto-friendly' },
                                { title: 'Mwali (Comoros)', text: 'International recognition, affordable packages' },
                                { title: 'Malta', text: 'EU credibility, strict compliance, B2C & B2B gaming'},
                                { title: 'Curacao', text: 'Established jurisdiction, widely accepted'},
                                { title: 'Isle of Man', text: 'Reputable, high credibility for operators'},
                                { title: 'Cyprus', text: 'EU licensing for land-based & online betting'},
                                { title: 'Kahnawake (Canada)', text: 'Recognized licensing for North American markets'},
                            ]
                        }
                        end='Each jurisdiction has different costs, timelines, and requirements. We help you select the best option for your business model.'
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Our Gaming License Support Includes'
                        services={
                            [
                                { icon: SiCheckmarx, title: "company-formation & Setup" },
                                { icon: SiCheckmarx, title: "License Application Preparation & Submission" },
                                { icon: SiCheckmarx, title: "Regulatory Compliance (AML, KYC, Fair Gaming Rules)" },
                                { icon: SiCheckmarx, title: "Banking & PSP Integration" },
                                { icon: SiCheckmarx, title: "Crypto Payment Gateways" },
                                { icon: SiCheckmarx, title: "White-Label Gaming Platforms", text: "(casino, sportsbook, lottery)"},
                                { icon: SiCheckmarx, title: "Affiliate Program Structuring" },
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Delivery Timeline'
                        items={[
                            {
                                name: "Fast Offshore Jurisdictions",
                                description: "(Western Sahara, Mwali, Anjouan)",
                                duration: "4–8 weeks",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Malta, Isle of Man, Cyprus",
                                description: "6–10 months",
                                background: "#FEF3C7",
                                border: "#FDE68A"
                            },
                            {
                                name: "Curacao, Kahnawake",
                                description: "6–10 weeks",
                                background: "#F3E8FF",
                                border: "#E9D5FF"
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Ready to launch your gaming business?'
                         description='From <b>offshore licenses</b> to <b>EU-recognized jurisdictions,</b> Offshore Advisory provides turnkey gaming license solutions.'
                         buttonText='Book a Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

export default GamingLicenseServices;

const faqData = [
    {
        question: "Which gaming license is best for startups?",
        content: [
            { type: "answer", text: "Western Sahara, Anjouan, and Mwali offer fast, affordable entry-level licenses." },
        ],
    },
    {
        question: "Can I operate globally with one license?",
        content: [
            { type: "answer", text: "Yes, offshore licenses provide international recognition, but EU markets often require EU-issued licenses (like Malta or Cyprus)." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "From 4–8 weeks offshore to 4–6 months in EU jurisdictions." },
        ],
    },
    {
        question: "Do I need a separate license for crypto gaming?",
        content: [
            { type: "answer", text: "Yes, certain regulators (e.g., Western Sahara CRA, Anjouan) explicitly cover crypto gaming." },
        ],
    },
    {
        question: "Can you also provide a gaming platform?",
        content: [
            { type: "answer", text: "Yes — we deliver white-label casino & sportsbook solutions along with licensing." },
        ],
    },
];

const testimonialsData = [
    {
        quote:
            "Offshore Advisory helped us secure a Curacao license and integrate payment gateways within 2 months.",
        author: "James R.",
        role: "Casino Operator",
    },
    {
        quote:
            "Thanks to their guidance, we launched a crypto gaming platform under Western Sahara CRA. Smooth and professional.",
        author: "Elena S.",
        role: "iGaming Entrepreneur",
    },
];